<template>
    <div>
        <div class="container">
            <h1>Hoi {{login_name}}, je bent bij vraag {{questions.length}} van de 17 <i class="fas fa-database align-right color-gray"> SQL</i> <a href="https://app.quickdatabasediagrams.com/#/d/LwuAyB" target="_blank" class="align-right">ERD </a> <router-link v-if="teacher=='true'"  to="/dashboard" class="align-right">Dashboard</router-link> </h1>
                <ul>
                    <li>Score vragen:</li>
                    <li v-for="(item, name, index) in questions">
                        <div class="score" @click="item.pivot.solved==1 ? getQuestion(item.id) : getQuestions()" v-bind:class="[{ correct: (item.pivot.solved!=0)},'n'+item.pivot.attemps, {n6:(item.pivot.attemps > 5)}]">
                            {{item.id}}
                        </div>
                    </li>
                </ul>

        </div>
        <div class="container">
            <h2 v-if="question.number"> Vraag: {{question.text}}</h2>
            <h2 v-else>{{question.text}} <p>Klik op een nummer om die vraag nogmaals te proberen.</p></h2>
            <div>
                <textarea v-bind:class="{ perfect: correct, incorrect : (correct == false)}" v-model="answer" v-if="question.number"></textarea>
                <button v-on:click="pushAnswer"  v-if="correct != true && question.number && !oldId">Check</button>
                <button v-on:click="pushOldAnswer(oldId)" :disabled="correct" v-if="oldId">Check</button>

                <button v-on:click="getQuestions" v-if="correct && !oldId ">Volgende vraag</button>
            </div>
        </div>
        <div class="container" v-if="response">
            <h2><i v-bind:class="{ 'fas fa-check color-green': correct, 'fas  fa-times color-red' : (correct == false)}"></i> MySql response</h2>

            <table>
                <thead>
                <tr>
                    <th v-for="(column ,index) in response[0]" >
                        {{index}}
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr class="response" v-for="(row,item,key) in response">
                      <td v-for="(item ,index) in row">{{item}}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</template>

<script>
    import {store} from '../imports/store';
    import axios from 'axios'
    import VueAxios from 'vue-axios'
    Vue.use(VueAxios, axios)
    axios
        .interceptors
        .request
        .use(function (config) {
            if (localStorage.getItem('user-token')) {
                config.headers['Authorization'] = 'Bearer '+localStorage.getItem('user-token');
            }
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
    window.axios = require('axios');
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    export default {

        name: "SqlLesComponent",
        data() {
            return{
                login_name : store.getters.getLoginName,
                questions:store.getters.getquestions,
                question : '',
                correct : null,
                response : null,
                answer : null,
                bearrer : null,
                teacher : store.getters.getIsTeacher,
                oldId : null
            }
        },
        created() {
            let config = {
                headers: {
                    method: 'post',
                    url: baseURI,
                    'Authorization' :
                        'Bearer '+localStorage.getItem('user-token')
                }
            };
                    const baseURI = '/api/user';
            //console.log('config 1',config);
            if (store.getters.getLoginName == 'undefined'){
                this.$http.post(baseURI,'',config).then((result) => {
                                    this.login_name = result.data.name;

                                    let name = result.data.name;
                                    this.teacher = result.data.email;
                                    localStorage.setItem('username',result.data.name);
                                    store.dispatch('setLoginName',{name});
                                    this.bearrer = localStorage.getItem('user-token');
                                })
            }
               this.getQuestions();

        },

        methods :{
            getQuestion(questionid){
                const AuthStr = 'Bearer '+localStorage.getItem('user-token');
                axios.get('/api/question/'+questionid, { headers: { Authorization: AuthStr } }).then(resp => {
                    this.question = resp.data.question
                    this.answer = resp.data.answer
                    this.attemps = resp.data.attemps;
                    this.solved = resp.data.solved;
                    this.oldId = questionid;
                    this.correct = null;
                })
            },
            getQuestions  :function () {

                //console.log('bearrer getQuestion:',localStorage.getItem('user-token'));
                let config = {
                    headers: {
                        method: 'post',
                        url: '/api/questions',
                        withCredentials: true,
                        'Authorization' :
                            'Bearer '+localStorage.getItem('user-token')
                    }
                };
               // console.log('config 2',config);
                const baseURI = '/api/questions';
                this.$http.post(baseURI,'',config).then((result) => {
                    this.question = result.data.question;
                    this.questions = result.data.questions;
                    this.correct = null;
                    this.oldId = null;


                }, error => {
                    if (error.response.status === 401) {

                        store.dispatch('setLoginName','');
                        store.dispatch('setIsTeacher','');
                        localStorage.setItem('isTeacher','');
                        localStorage.setItem('user-token', '');
                        this.$router.push('/login');
                    }
                    return error;
                })
            },
            pushAnswer:function(){
                let config = {
                    headers: {
                        method: 'post',
                        url: baseURI,
                        'Authorization' :
                            'Bearer '+localStorage.getItem('user-token')
                    }
                };
                const baseURI = '/api/answer';
                this.$http.post(baseURI,{'answer':this.answer},config).then((result) => {
                    this.response = result.data.mysql;
                    this.correct = result.data.correct;
                    this.questions[this.question.number-1].pivot.attemps++ //= this.questions[this.question.number-1].pivot.attemps+1;
                    if(this.correct){
                        this.questions[this.question.number-1].pivot.solved = 1;
                    }

                })
            },
            pushOldAnswer(questionid){
                const baseURI = '/api/answer/'+questionid;
                let config = {
                    headers: {
                        method: 'post',
                        url: baseURI,
                        'Authorization' :
                            'Bearer '+localStorage.getItem('user-token')
                    }
                };

                console.log('url',baseURI);
                this.$http.post(baseURI,{'answer':this.answer},config).then((result) => {
                    this.response = result.data.mysql;
                     this.correct = result.data.correct;
                   // this.questions[this.question.number-1].pivot.attemps++ //= this.questions[this.question.number-1].pivot.attemps+1;
                   // if(this.correct){
                   //     this.questions[this.question.number-1].pivot.solved = 1;
                   // }

                })
            },
        }
    }

</script>

<style scoped>
    textarea{
      height: 180px;
    }
    button {
        width: 80%;
        height: 30px;
        font-size: large;
        color:white;
        background-color: #3490dc;
        border: grey;
        box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);

    }
    p{
        width: 80%;
        margin: 0 auto 0 auto;
    }
    ul{
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
    li  {
        display: inline;
        color: white;
        text-align: center;
        padding: 3px;
        text-decoration: none;
    }
    li > div {
        color:blue;
    }
    .score{
        display: inline-block;
        width: 30px;
        background-color: #f8fafc;
        cursor: pointer;
    }
    .correct{
        background-color: #ca700d;
        color: #f8fafc;
    }
    .n1{
        background-color: #36ca2b;
        color: #f8fafc;
    }
    .n2{
        background-color: #9dca35;
        color: #f8fafc;
    }
    .n3{
        background-color: #b8ca3c;
        color: #f8fafc;
    }
    .n4{
        background-color: #c4ca30;
        color: #f8fafc;
    }
    .n5{
        background-color: #caad22;
        color: #f8fafc;
    }
    .n6{
        background-color: rgba(255, 18, 0, 0.76);
        color: #f8fafc;
    }
    .perfect{
        border: greenyellow;
        box-shadow: 0 5px 15px 0px rgba(5, 202, 28, 0.6);
    }
    .incorrect{
        border: red;
        box-shadow: 0 5px 15px 0px rgba(255, 18, 0, 0.76);
    }
    a{
        text-decoration: none;
        color: white;
    }

</style>
